global.allSMSList = global.API_ADMIN_URL+'allSMSList/';
global.smsTypeDetails = global.API_ADMIN_URL+'smsTypeDetails/';
global.addNewSMSTemplate = global.API_ADMIN_URL+'addNewSMSTemplate/';
global.editSMSTemplate = global.API_ADMIN_URL+'editSMSTemplate/';
global.smsManageStatus = global.API_ADMIN_URL+'smsManageStatus/';
global.smsManageDLTStatus = global.API_ADMIN_URL+'smsManageDLTStatus/';
global.smsManageDelete = global.API_ADMIN_URL+'smsManageDelete/';
global.allPendingSMSList = global.API_ADMIN_URL+'allPendingSMSList/';
global.smsManagePendingStatus = global.API_ADMIN_URL+'smsManagePendingStatus/';